import Vue from 'vue'
import Router from 'vue-router'

import Home from '../views/Home'
import Shop from '../views/Shop'
import Events from '../views/Events'
import ShopSingle from '../views/ShopSingle'
import EventSingle from '../views/EventSingle'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/shop',
      name: 'Shop',
      component: Shop
    },
    {
      path: '/events',
      name: 'Events',
      component: Events
    },
    {
      path: '/shop/:single',
      name: 'ShopSingle',
      component: ShopSingle
    },
    {
      path: '/events/:single',
      name: 'EventSingle',
      component: EventSingle
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js